module.exports = {
  retrieveUser: (user_details, userDocs) => {
    return userDocs[user_details.owner_id];
  },
  retrieveUserOld: (user_details, userDocs) => {
    let user_complete = false;
    try {
      let query = userDocs.find(x => x.id === user_details['owner_id']);
      if (query) {
        user_complete = {
          ...user_details,
          ...query
        }
      }
    } catch (error) {
      //
    }
    return user_complete;
  }
};
